import { render } from "./InputMoeda.vue?vue&type=template&id=423f42bf&scoped=true"
import script from "./InputMoeda.vue?vue&type=script&lang=js"
export * from "./InputMoeda.vue?vue&type=script&lang=js"

import "./InputMoeda.vue?vue&type=style&index=0&id=423f42bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-423f42bf"]])

export default __exports__